import React from "react";

export function LabelRender(labelText: string[]) {
    return function template(data) {
        return (<div className="dx-field-item-label-text" >
            {labelText.map((text, index: number) => (
                <div key={index}>
                    {text}
                    {index !== labelText.length - 1 && <br />}
                </div>
            ))}
        </div>)
    }

}